import styled from 'styled-components';

const MyDiv = styled.div`

  .profile_menu {
    border: 1px solid #EEF3FB;
    padding: 1px 15px;
    width: 100%;
    border-radius: 8px;
  }
  .profile_menu button {
    background: transparent;
    padding: 0;
  }
  .profile_menu button:hover {
    background: transparent;
  }
  .dropdown_list {
    padding: 0;
    border: 0;
    box-shadow: 0px 1px 15px #D0D5DD;
    width: 100%;
    border-radius: 8px;
  }
  .logout_user {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .divider {
    border-color: #EAECF0;
    opacity: 1;
  }
  .profile_menu button .chakra-button__icon .chakra-avatar {
    width: 32px;
    height: 32px;
    background: rgb(17, 17, 17);
  }
  .profile_menu button .chakra-button__icon .chakra-avatar div {
    font-size: 16px;
    color: rgb(255, 255, 255);
    font-weight: 400;
    font-family: Poppins, sans-serif;
  }

  /* 🔔 Blink animation for bell icon */
  .blink_bell svg {
    animation: bellBlink 4s infinite alternate;
  }

  /* 🔴 Pulse animation for notification badge */
  .blink_badge {
    animation: pulse 5s infinite;
    box-shadow: 0 0 0 rgba(255, 0, 0, 0.4);
  }

  @keyframes bellBlink {
    0% {
      opacity: 0.5;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.05);
    }
    100% {
      opacity: 0.5;
      transform: scale(1);
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.6);
    }
    70% {
      transform: scale(1.15);
      box-shadow: 0 0 10px 5px rgba(255, 0, 0, 0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
    }
  }
`;

export default MyDiv;
